<template>
    <div class="Poster">
        <Header msg="长按保存图片"/>
        <!-- <img :src="poster" class="Poster-img" :style="tabH"/> -->
        <!-- <img :src="poster" class="Poster-img"/> -->
        <img :src="poster" :class="isloading ? 'Poster-imgs':'Poster-img'" :style="tabH" id="pos"/>
        <div class="poster-bottom">
          <div class="tips">保存图片并复制下方文案，分享给好友</div>
          <div class="flex flex-j-c-sb">
            <p class="poster-p ellipsis-more">{{context}}</p>
            <div class="poster-btn" @click="copyChannel(context)">复制</div>
          </div>
        </div>
    </div>
</template>

<script>
import Header from '@/components/Header.vue';
import { getPoster, REQUEST_BASE } from '@/api';
import copy from 'copy-to-clipboard';
import { Toast } from 'mint-ui';

export default {
    name: 'Poster',
    components: {
      Header
    },
    data() {
      return {
        tabH: '', // 海报样式
        poster: require('@/assets/loading.gif'), // 海报默认图
        isloading: false, // 是否加载中
        context: '' // 显示介绍词
      }
    },
    created() {
    },
    mounted() {
      // let he = document.body.clientHeight, botHe = document.getElementsByClassName('poster-bottom'),wi = document.body.clientWidth;
      // this.tabH = `height:${he - 44}px`;
      // console.log(he, botHe[0].clientHeight, wi);
      this.posterImg();
    },
    methods: {
      // 获取海报
      posterImg() {
        let id = JSON.parse(localStorage.getItem('cww_data')).id;
        getPoster({url: `${REQUEST_BASE()}?id=${id}&type=invi`,playbill_id: this.$route.query.playbill_id}).then(res => {
          if (res.code === 0) {
            this.poster = res.data;
            this.context = res.content;
          }
        })
      },
      // 加载图片，图片处理
      loadImg() {
        let that = this;
        var img_url = this.poster;
        var img = new Image();
        img.src = img_url;
        let he = document.body.clientHeight, botHe = document.getElementsByClassName('poster-bottom'), wi = document.body.clientWidth;
        img.onload = function() {
          let imgW = wi*0.9;
          let imgH = img.height / (img.width / imgW);
          // console.log('默认：', he, botHe, wi, imgW, imgH, img.width, img.height)
          if (imgH > (he - botHe[0].clientHeight - 44)) {
            imgH = (he - botHe[0].clientHeight - 44) * 0.95;
            imgW = img.width / (img.height / imgH);
            // console.log('一：', he, botHe, wi, imgW, imgH)
          };
          if (imgW > (wi*0.9)) {
            imgH = (he - botHe[0].clientHeight - 44) * 0.95;
            imgW = wi*0.9;
            // console.log('二：', he, botHe, wi, imgW, imgH)
          };
          let imgTOP = (he - botHe[0].clientHeight - 44 - imgH) * 0.5 + 44;
          that.tabH = `width:${imgW}px;height:${imgH}px;top:${imgTOP}px`;
          that.isloading = true;
          // console.log('最终结果：', he, botHe, wi, imgW, imgH)
        }
      },
      // 复制文字
      copyChannel(e) {
        copy(e);
        Toast({message: '文案已复制', duration: 1500});
      }
    },
    watch: {
      poster(n, o) {
        let that = this;
        that.$nextTick(function () {
          that.loadImg();
        })
      }
    }
}

</script>
<style lang='less' scoped>
.Poster{
    height: 100vh;
    width: 100%;
    font-size: 0;
    background: #eee;
    top: 0;
    left: 0;
    .mint-header{
      height: 44px;
    }
    .Poster-img{
      margin: 0 0 0.8rem;
      width: 85%;
      height: auto;
      max-height: 70vh;
      position: absolute;
      top: 47%;
      left: 50%;
      transform: translate(-50%,-50%);
      border-radius: 6px;
      box-shadow: 0 7px 12px 0 rgba(0, 0, 0, 0.2);
    }
    .Poster-imgs{
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      border-radius: 6px;
      box-shadow: 0 7px 12px 0 rgba(0, 0, 0, 0.2);
    }
    .poster-bottom{
      position: absolute;
      bottom: 0;
      left: 0;
      height: 0.8rem;
      width: 100%;
      background: white;
      .tips{
        background: rgb(70, 211, 70);
        color: white;
        width: 100%;
        height: 0.3rem;
        line-height: 0.3rem;
        font-size: 0.12rem;
      }
      .poster-p{
        width: 80%;
        text-align: left;
        font-size: 0.14rem;
        padding: 0.05rem 0.1rem;
        -webkit-line-clamp: 2;
        height: 0.47rem;
        line-height: 0.2rem;
        color: #999;
      }
      .poster-btn{
        margin: 0.1rem 0.1rem;
        width: 0.6rem;
        height: 0.3rem;
        line-height: 0.3rem;
        color: rgb(70, 211, 70);
        border: 1px solid rgb(70, 211, 70);
        border-radius: 0.2rem;
        font-size: 0.14rem;
      }
    }
}
</style>